// Axios
import Axios from "./axios"

export const getUpdatedNews = (contentSelected) => {
    return new Promise((resolve, reject) => {
        const data = Axios.get(`/news/updatedLimit`, {
            params: {
                contentSelected: contentSelected
            }
        })
        setTimeout(() => resolve(data), 1000)
    })

}